@let titleResponse = this.titleId();
@let subtitleResponse = this.subtitleId();
@let secondaryButtonResponse = this.secondaryButtonId();
@let highlightButtonResponse = this.highlightButtonId();
@let heroImageResponse = this.heroImageId();
<div class="hero">
    @if (heroImageResponse.success) { 
    <app-editable-image 
        [elemId]="heroImageResponse.payload"
        [imageReference]="imageReference"
        [customClass]="'hero-custom-class-image'"
        [fileTypes]="supportedFileTypes"
        [maxWidth]="1920"
        [maxHeight]="1080"
        [topSpacing]="'120px'"
        [hasPriority]="true"
        >
    </app-editable-image>
    }
    <div class="overlay">
        <div class="content">
            @if(titleResponse.success){<app-editable-text [customClass]="'hero-custom-class-text'" [elemId]="titleResponse.payload"></app-editable-text>}
            @if(subtitleResponse.success) {<app-editable-text [customClass]="'hero-custom-class-text'" [elemId]="subtitleResponse.payload"></app-editable-text>}

            <div class="button-container">
                @if(secondaryButtonResponse.success) { 
                    @if (!isSmallScreen$()) { <app-editable-button [elemId]="secondaryButtonResponse.payload"></app-editable-button> }
                }
                @if(highlightButtonResponse.success) {   
                <app-editable-button [elemId]="highlightButtonResponse.payload"></app-editable-button> 
                }
            </div>
        </div>
    </div>
</div>